import React, { useState } from 'react'
import CurrencyInput from 'react-currency-input-field';
import { isNullOrEmpty, isNullUndefinedOrEmpty } from '../../../common/Helpers';
import { __OBJECT_STRUCTURE_globalNumberConfig } from '../../../common/ObjectStructures/sKPI';
import CValidator from '../CValidator';
import { t } from 'i18next';

function CCurrencyTextBox(props) {

    //Parametros de entrada.
    const inputParam_LabelText = props.labelText !== null && props.labelText !== undefined ? props.labelText : null;
    const inputParam_ControlValue = props.controlValue !== null && props.controlValue !== undefined ? props.controlValue : "";
    const inputParam_IsInvalidControl = props.isInvalidControl !== null && props.isInvalidControl !== undefined ? props.isInvalidControl : false;
    const inputParam_ObjectPropertyNameForSetter = props.objectPropertyNameForSetter !== null && props.objectPropertyNameForSetter !== undefined ? props.objectPropertyNameForSetter : null;
    const inputParam_SetterControlValue = props.setterControlValue !== null && props.setterControlValue !== undefined ? props.setterControlValue : null;
    const inputParam_SetterIsPropertyObject = props.setterIsPropertyObject !== null && props.setterIsPropertyObject !== undefined ? props.setterIsPropertyObject : false;
    const inputParam_Disabled = props.disabled !== null && props.disabled !== undefined ? props.disabled : false;
    const inputParam_InvalidText = props.invalidText !== null && props.invalidText !== undefined ? props.invalidText : null;
    const inputParam_TextBoxName = props.textBoxName !== null && props.textBoxName !== undefined ? props.textBoxName : null;
    const inputParam_UseControlNameForSetter = props.useControlNameForSetter !== null && props.useControlNameForSetter !== undefined ? props.useControlNameForSetter : false;
    const inputParam_Min = props.min !== null && props.min !== undefined ? props.min : undefined;
    const inputParam_AllowDecimals = props.allowDecimals !== null && props.allowDecimals !== undefined ? props.allowDecimals : true;
    
    //Parametros de componente.
    const [isInvalidControl, setIsInvalidControl] = useState(false);
    const [invalidText, setInvalidText] = useState(null);

    const componentTextBoxCurrencyConfig = __OBJECT_STRUCTURE_globalNumberConfig()

    //Funciones de componente.
    const isInValidFormControl = (value) => {
        let flagIsInvalid = false;

        if (value !== "" && value !== null && value !== undefined) {
            let valueString = value.toString();

            let numeralValueComplete = valueString.indexOf(',') !== -1 ? valueString.split(',')[0] : valueString;
            let decimalValueComplete = valueString.indexOf(',') !== -1 ? valueString.split(',')[1] : "";
    
            let numeralValueClean = numeralValueComplete.replace(".", "")
            let decimalValueClean = decimalValueComplete.replace(".", "")
    
            if (numeralValueClean.length > 13) {
                flagIsInvalid = true;
                setInvalidText("data-lang-msg-numberlengthexedded")
            }
            else if (decimalValueClean.length > 5) {
                flagIsInvalid = true;
                setInvalidText("data-lang-msg-decimallengthexedded")
            }
        }
        else {
            if (inputParam_InvalidText === null) {
                setInvalidText("data-lang-msg-required")
            }
            else {
                setInvalidText(inputParam_InvalidText)
            }
        }

        return flagIsInvalid;
    }

    const checkIfIsInvalidControl = () => {
        const _isInvalidControl = isInvalidControl !== null ? isInvalidControl : false;
        const _inputParam_IsInvalidControl = inputParam_IsInvalidControl !== null ? inputParam_IsInvalidControl : false;

        if (invalidText === t('data-lang-msg-minvalue0')) {
            if (inputParam_ControlValue === "" || inputParam_ControlValue > 0) {
                setInvalidText(null);
                setIsInvalidControl(false);
            }
        }

        return _isInvalidControl === true | _inputParam_IsInvalidControl === true ? true : false;
    }

    //Eventos de componente.
    const onChangeValue = (value) => {
        if (!isNullUndefinedOrEmpty(inputParam_Min)) {
            if (value < 0) {
                normalValueAsignation(0)
                setInvalidText(t('data-lang-msg-minvalue0'))
                setIsInvalidControl(true);
            }
            else {
                setIsInvalidControl(false);
                setInvalidText(null)
                normalValueAsignation(value)
            }
        }
        else {
            setIsInvalidControl(false);
            setInvalidText(null)
            normalValueAsignation(value)
        }
    };

    const normalValueAsignation = (value) => {
        setIsInvalidControl(isInValidFormControl(value));

        if (inputParam_SetterIsPropertyObject) {
            inputParam_SetterControlValue && inputParam_SetterControlValue(prevState => ({
                ...prevState,
                [inputParam_ObjectPropertyNameForSetter]: value
            }));
        }
        else {
            if (inputParam_UseControlNameForSetter) {
                inputParam_SetterControlValue && inputParam_SetterControlValue(value, inputParam_TextBoxName);
            }
            else {
                inputParam_SetterControlValue && inputParam_SetterControlValue(value);
            }
        }
    }

    //Render de componente.
    return (<div className="ms-TextField">
                <div className="ms-TextField-wrapper">
                    {
                        inputParam_LabelText &&
                        <label className="ms-Label custom-txt-root">{ inputParam_LabelText }</label>
                    }
                    <div className="ms-TextField-fieldGroup custom-txt-fieldGroup">
                        <CurrencyInput
                            name={!isNullOrEmpty(inputParam_TextBoxName) ? inputParam_TextBoxName : undefined}
                            defaultValue={null}
                            className="ms-TextField-field custom-txt-field"
                            decimalsLimit={componentTextBoxCurrencyConfig.decimalsLimit}
                            allowDecimals={!isNullUndefinedOrEmpty(inputParam_AllowDecimals) ? inputParam_AllowDecimals : true}
                            decimalSeparator={componentTextBoxCurrencyConfig.decimalSeparator}
                            groupSeparator={componentTextBoxCurrencyConfig.groupSeparator}
                            onValueChange={ onChangeValue }
                            value={inputParam_ControlValue}
                            disabled={inputParam_Disabled}
                            style={{backgroundColor: inputParam_Disabled ? '#f3f2f1' : undefined}}
                            
                        />
                    </div>
                    <CValidator inValidText={ invalidText } isInValid={ checkIfIsInvalidControl() } />
                </div>
            </div>
    );
}

export default CCurrencyTextBox;

